import { useMemo } from 'react';
export default function useResponsiveValue(themeAccessor, responsiveValue) {
    return useMemo(function () { return themeAccessor.resolveResponsiveValue(responsiveValue); }, [responsiveValue]);
}
//# sourceMappingURL=UseResponsiveValue.js.map